import $ = require('jquery');
import NavDropZone = require('./NavDropZone');
/**
 * Drop zone for the navigation items directly visible on the page
 */

    class MainNavDropZone extends NavDropZone {
        constructor(targetEl: JQuery) {
            super($("<div></div>"), targetEl);

            let menuUl = this.getTargetEl().closest('ul');
            let isVertical = menuUl.data('diy-dd-is-vertical-layout');
            if (isVertical === null) {
                isVertical = true;
                let previousOffset = {top: -1};
                let currentOffset: JQueryCoordinates;
                // select only direct children and check if they're all
                // vertically positioned
                menuUl.find(' > li').each((index, elem) => {
                    currentOffset = $(elem).offset();
                    if (currentOffset.top <= previousOffset.top) {
                        isVertical = false;
                        return false;
                    }
                    previousOffset = currentOffset;
                    return undefined;
                });
                menuUl.data('diy-dd-is-vertical-layout', isVertical);
            }
        }
        activate() {
            this.element
                .wrap('<div class="diye"></div>')
                .parent()
                .appendTo('body');

            let targetEl = this.getTargetEl();
            this.element
                .width(targetEl.innerWidth())
                .height(targetEl.innerHeight())
                .css({
                    'position': targetEl.closest(":fixed").length > 0 ? 'fixed' : 'absolute',
                    'top': 0,
                    'left': 0,
                    'z-index': targetEl.diy_zIndex() + 1
                })
                .position({
                    my: 'left top',
                    at: 'left top',
                    of: targetEl
                });

            super.activate();
        }

        showInvitation(canDrop: boolean) {
            this.element.addClass(canDrop ? 'nav-can-drop' : 'nav-cannot-drop');
        }

        hideInvitation() {
            this.element.removeClass('nav-can-drop nav-cannot-drop');
        }

        isVerticalNav() {
            return this.getTargetEl().closest('ul').data('diy-dd-is-vertical-layout');
        }

        deactivate() {
            super.deactivate();

            this.element
                    .parent()
                    .remove();
        }
    }

export = MainNavDropZone;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/MainNavDropZone.ts
 **/